<template>
  <div id="orderDetail">
    <!-- 订单详情 -->
    <div class="header">
      <p>交易状态：<span v-text="stateFilter(detail.orderStatus)"></span></p>
      <img
        src="@/static/images/other/finish.png"
        v-if="(orderFlag == 1 && state == 0) || (state == 1 && orderFlag == 2)"
      />
      <img
        src="@/static/images/other/shouhou.png"
        v-if="orderFlag == 1 && state == 1"
      />
      <img
        src="@/static/images/other/ing.png"
        v-if="state == 0 && orderFlag == 2"
      />
    </div>
    <div class="middle">
      <div class="inner">
        <div class="img-box">
          <img v-if="orderFlag == 2" src="@/static/images/other/pia_s.png" />
          <img v-if="orderFlag == 1" :src="host + detail.goodsPhoto" />
        </div>
        <div>
          <p class="name" v-if="orderFlag == 1">{{ detail.goodsName }}</p>
          <p class="name" v-if="orderFlag == 2">{{ detail.ticketName }}</p>
          <p v-if="orderFlag == 1">交易趣豆：{{ detail.orderPrice }}</p>
          <p v-if="orderFlag == 2">交易面值：{{ detail.ticketPrice }}元</p>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <ul class="detail" v-if="orderFlag == 1">
      <li>订单号：{{ detail.orderNo }}</li>
      <li>交易时间：{{ detail.createTime }}</li>
      <div v-show="detail.orderStatus == 1 && detail.serviceStatus == 1">
        <li>售后原因：{{ detail.serviceDes }}</li>
        <li>售后发起时间：{{ detail.serviceSubmitTime }}</li>
      </div>
      <div
        v-show="
          detail.orderStatus == 0 &&
            (detail.serviceStatus == 2 || detail.serviceStatus == 3)
        "
      >
        <li class="reason">
          <div class="l">售后原因：</div>
          <div class="r">{{ detail.serviceDes }}</div>
        </li>
        <li>售后发起时间：{{ detail.serviceSubmitTime }}</li>
        <li>处理意见：{{ detail.serviceReply }}</li>
        <li>售后处理时间：{{ detail.serviceReplyTime }}</li>
        <li>
          售后处理结果：<span
            v-text="serviceStatus(detail.serviceStatus)"
          ></span>
        </li>
      </div>
    </ul>
    <ul class="detail" v-if="orderFlag == 2">
      <li>订单号：{{ detail.orderNo }}</li>
      <li>折扣金额：{{ detail.orderPrice }}元</li>
      <li>折扣比例：{{ detail.ratio }}%</li>
      <li>交易时间：{{ detail.createTime }}</li>
      <li>转让时间：{{ detail.finishTime || "-" }}</li>
      <li>收款人：{{ detail.receivePerson }}</li>
      <li>身份证号：{{ detail.idCard }}</li>
      <li>开户行：{{ detail.receiveBank }}</li>
      <li>收款账号：{{ detail.receiveAccount }}</li>
    </ul>
    <div class="btn" v-show="orderFlag == 1">
      <!-- <mt-button size="large" type="primary" @click="use()">去使用</mt-button> -->
      <mt-button
        size="large"
        type="default"
        @click="toAfterSale()"
        v-show="orderFlag == 1 && detail.serviceStatus == 0"
        >申请售后</mt-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      state: "", // 趣豆 0完成 1售后     转让 1完成 0进行中
      orderFlag: "", // 1趣豆订单 2转让订单
      orderId: "", //订单ID
      detail: {
        orderStatus: 0,
        goodsName: "",
        id: "",
      }, //订单详情
    };
  },
  mounted() {
    this.orderFlag = this.$route.params.id;
    this.orderId = this.$route.params.orderId;
    if (this.orderFlag == 1) {
      this.getDetail("getOrderBuyDetail");
      document.title = "订单详情";
    }
    if (this.orderFlag == 2) {
      this.getDetail("myOrderTransferDetail");
      document.title = "转让详情";
    }
  },
  beforeDestroy() {
    // this.changeRouter("/orderList/" + this.orderFlag);
  },
  methods: {
    // myOrderTransferDetail   getOrderBuyDetail
    //订单详情
    getDetail(api) {
      this.post(this.apis[api], {
        orderId: this.orderId,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.detail = response.data;
            this.state = response.data.orderStatus;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //去使用
    use() {},
    serviceStatus(state) {
      let ret = "";
      switch (parseInt(state)) {
        case 0:
          ret = "未提售后";
          break;
        case 1:
          ret = "已提未处理";
          break;
        case 2:
          ret = "通过";
          break;
        case 3:
          ret = "驳回";
          break;
      }
      return ret;
    },
    // 0:未提售后,1:已提未处理,2:通过，3驳回
    stateFilter(state) {
      if (
        (this.orderFlag == 1 && state == 0) ||
        (state == 1 && this.orderFlag == 2)
      ) {
        return "已完成";
      }
      if (this.orderFlag == 1 && state == 1) {
        return "售后";
      }
      if (this.orderFlag == 2 && state == 0) {
        return "进行中";
      }
    },
    toAfterSale() {
      this.$router.push({
        name: "AfterSale",
        params: { id: this.detail.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
#orderDetail {
  .header {
    width: 750px;
    height: 149px;
    background-color: #1fbe6e;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      padding-left: 62px;
      font-family: PingFang-SC-Regular;
      font-size: 26px;
      color: #ffffff;
    }
    img {
      padding-right: 108px;
      width: 149px;
      height: 131px;
      opacity: 0.39;
    }
  }
  .middle {
    height: 230px;
    .inner {
      margin: 0 52px;
      padding-top: 44px;
      height: 140px;
      display: flex;
      .img-box {
        margin-right: 30px;
        width: 140px;
        height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      p {
        font-family: PingFang-SC-Regular;
        font-size: 24px;
        color: #3a3a3a;
        &.name {
          width: 470px;
          font-family: PingFang-SC-Bold;
          font-size: 30px;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 27px;
        }
      }
    }
  }
  .line {
    height: 13px;
    background-color: #f5f5f5;
  }
  .detail {
    margin: 0 50px;
    padding-top: 42px;
    font-family: PingFang-SC-Regular;
    color: #3a3a3a;
    li {
      font-size: 24px;
      width: 650px;
      padding-bottom: 20px;
      &.reason {
        display: flex;
        line-height: 40px;
        .l {
          flex: 0 0 120px;
        }
      }
    }
  }
  .btn {
    padding: 50px;
    .mint-button--default {
      margin-top: 50px;
    }
  }
}
</style>
